export default "/fonts/SegoeUI-Bold.woff2?807ece02055cce271551171fdad2b809";